import { InputTag } from 'mixs/base/input_mixin';
import Timelag from 'utilities/timelag';
export class SearchRadioOrder extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  onChange(e){
    this.dispatch({value: e.target.value});
  }
}
riot.mixin('inputs.search.radio-order', SearchRadioOrder as riot.TagMixin)
